<template>
  <v-container class="fill-height justify-center align-center">
    <LoginCard
      :is-loader-shown="isLoginLoaderShown"
      :is-otp-shown="isOtpShown"
      @on-log-in="logIn"
    />
  </v-container>
</template>

<script lang="ts" setup>
  // import composable
  import useAuth from '@/composables/useAuth/useAuth';
  import { useNotificationStore } from '@/store/notificationStore';
  import { ref } from 'vue';
  // import components
  import LoginCard from '@/pages/auth/partials/LoginCard.vue';

  // import types
  import ApiLoginResponse from '@/types/ApiLogInResponse';

  const isLoginLoaderShown = ref(false);
  const isOtpShown = ref(false);

  const { logInUser } = useAuth();
  const notificationStore = useNotificationStore();

  let logIn = (e: { email: string; password: string; otp: string }) => {
    const fetch = logInUser(e.email, e.password, e.otp);
    isLoginLoaderShown.value = true;
    isOtpShown.value = false;

    fetch.onFetchError(() => {
      let errorMessage = 'Password Change failed. Please try again.';
      notificationStore.addErrorNotification(errorMessage);
    });

    fetch.onFetchFinally(() => {
      isLoginLoaderShown.value = false;
      let { status, data } = JSON.parse(
        fetch.data.value as string
      ) as ApiLoginResponse;

      if (data === 'OTP mismatch') {
        let errorMessage = String(data);
        notificationStore.addWarningNotification(errorMessage);
        isOtpShown.value = true;
      }

      if (status === 'error' && data !== 'OTP mismatch') {
        let errorMessage = 'Login failed. ' + String(data);
        notificationStore.addErrorNotification(errorMessage);
      }
    });
  };
</script>
